import React from 'react';
import {Draggable} from 'react-beautiful-dnd';
import {Grid, Tooltip} from '@mui/material';
import {
  FontStyle,
  WidgetStyle
} from '../widgets-menu-list/WidgetsMenuListStyle';
import IconComponent from '@components/icon/IconComponent';

const DraggableWidget = (props?: any): React.ReactElement => {
  const {widget, drawerOpen} = props;
  return (
    <Draggable draggableId={widget?.label} index={widget?.id}>
      {provided => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}>
          {/* Render your Zoho Creator widget based on the widgetType */}
          <Tooltip
            key={widget?.id}
            title={drawerOpen ? '' : widget?.label}
            placement="right"
            enterDelay={100}
            leaveDelay={50}>
            <Grid item xs={drawerOpen ? 6 : 12}>
              <WidgetStyle drawerOpen={drawerOpen}>
                <IconComponent iconName={widget?.icon} sx={{width: '100%'}} />
                {drawerOpen && <FontStyle>{widget?.label}</FontStyle>}
              </WidgetStyle>
            </Grid>
          </Tooltip>
        </div>
      )}
    </Draggable>
  );
};

export default DraggableWidget;
